// extracted by mini-css-extract-plugin
export default {"transaction":"ToTransaction_transaction__9-CxM","linkFlex":"ToTransaction_linkFlex__WayP4","button":"ToTransaction_button__sMn17"};